import { render, staticRenderFns } from "./StatsSDVChart.vue?vue&type=template&id=ddb911ca&scoped=true&"
import script from "./StatsSDVChart.vue?vue&type=script&lang=js&"
export * from "./StatsSDVChart.vue?vue&type=script&lang=js&"
import style0 from "./StatsSDVChart.vue?vue&type=style&index=0&id=ddb911ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb911ca",
  null
  
)

export default component.exports